<div style="height: calc(100vh - 70px); width: 100%; overflow: scroll; overflow-x: hidden;">
    <iframe
        src="https://api.genlogic.co.th/monitor/"
        style="height: 5800px; width: 100%"
        [frameBorder]="0"
        scrolling="no"
    ></iframe>
</div>
